/* Collection-only quick purchase and browser-local wishlist. No account or app required. */
(() => {
  if (window.roCollectionController) window.roCollectionController.destroy();
  const KEY = 'ryunosukeokazaki:wishlist:v1';
  const words = {
    en: { add: 'Add to cart', adding: 'Adding…', added: 'Added to cart.', choose: 'Please select an option.', preview: 'Preview only. Nothing was added to the cart.', error: 'Could not confirm the result. Check your cart before trying again.', empty: 'Your wishlist is empty.', remove: 'Remove', saved: 'Added to wishlist.', removed: 'Removed from wishlist.', storage: 'This browser cannot save your wishlist. These selections will be lost when you leave this page.', limit: 'Your wishlist is full. Remove an item before adding another.', quantity: 'Quantity', unavailable: 'This option is unavailable.' },
    ja: { add: 'カートに追加', adding: '追加中…', added: 'カートに追加しました。', choose: 'サイズ・オプションを選択してください。', preview: 'プレビューのため、カートには追加していません。', error: '追加の結果を確認できませんでした。カートを確認してから、もう一度お試しください。', empty: 'お気に入りはまだありません。', remove: '削除', saved: 'お気に入りに追加しました。', removed: 'お気に入りから削除しました。', storage: 'このブラウザーでは保存できません。このページを離れると選択内容が消えます。', limit: 'お気に入りが上限に達しました。商品を削除してから追加してください。', quantity: '数量', unavailable: 'このサイズ・オプションは現在選択できません。' }
  };
  const t = root => words[root.dataset.lang === 'ja' ? 'ja' : 'en'];
  let items = [];
  let previewItems = [];
  let storageOK = true;
  let active = null;
  let busy = false;
  let destroyed = false;
  const completed = new WeakSet();
  const listFor = root => root.dataset.editor === 'true' ? previewItems : items;

  function safeImage(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com')) ? url.href : '';
    } catch (_) { return ''; }
  }
  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(saved)) return;
      items = saved.filter(x => x && typeof x.id === 'string' && /^\d+$/.test(x.id) && typeof x.handle === 'string' && /^[\w-]+$/.test(x.handle) && typeof x.title === 'string').slice(0, 100).map(x => ({ id: x.id, handle: x.handle, title: x.title.slice(0, 200), material: String(x.material || '').slice(0, 100), image: safeImage(x.image || '') }));
    } catch (_) { storageOK = false; }
  }
  function save(root) {
    if (root.dataset.editor === 'true') return;
    try { localStorage.setItem(KEY, JSON.stringify(items)); storageOK = true; }
    catch (_) { storageOK = false; }
  }
  function say(root, message) {
    const status = root.querySelector('[data-ro-collection-status]');
    if (status) status.textContent = message;
  }
  function refresh() {
    document.querySelectorAll('[data-ro-collection]').forEach(root => {
      const saved = listFor(root);
      root.querySelectorAll('[data-ro-wishlist-count]').forEach(el => { el.textContent = saved.length; });
      root.querySelectorAll('[data-ro-card]').forEach(card => {
        const selected = saved.some(x => x.id === card.dataset.productId);
        const button = card.querySelector('[data-ro-wishlist-toggle]');
        if (!button) return;
        button.setAttribute('aria-pressed', String(selected));
        button.querySelector('[data-ro-wish-symbol]').textContent = selected ? '−' : '＋';
      });
    });
  }
  function productURL(root, handle) {
    if (!handle || !/^[\w-]+$/.test(handle)) return '';
    const prefix = root.dataset.rootUrl || '/';
    return prefix.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle);
  }
  function renderWishlist(root) {
    const list = root.querySelector('[data-ro-wishlist-items]');
    const status = root.querySelector('[data-ro-wishlist-status]');
    list.replaceChildren();
    const saved = listFor(root);
    saved.forEach(item => {
      const li = document.createElement('li');
      const photo = document.createElement('span');
      const src = safeImage(item.image);
      if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 64; img.height = 64; photo.append(img); }
      const info = document.createElement('div');
      const url = productURL(root, item.handle);
      const title = document.createElement(url ? 'a' : 'span');
      title.textContent = item.title;
      if (url) title.href = url;
      info.append(title);
      if (item.material) { const material = document.createElement('p'); material.textContent = item.material; material.className = 'ro-muted'; info.append(material); }
      const remove = document.createElement('button');
      remove.type = 'button'; remove.dataset.roWishlistRemove = item.id;
      remove.textContent = t(root).remove;
      remove.setAttribute('aria-label', t(root).remove + ': ' + item.title);
      li.append(photo, info, remove); list.append(li);
    });
    status.textContent = (!storageOK && root.dataset.editor !== 'true') ? t(root).storage : saved.length ? '' : t(root).empty;
  }
  function restore() {
    if (!active) return;
    const previous = active;
    active = null;
    document.documentElement.style.overflow = previous.overflow;
    if (previous.opener.isConnected) previous.opener.focus({ preventScroll: true });
  }
  function close() {
    if (!active) return;
    const dialog = active.dialog;
    restore();
    dialog.close();
  }
  function open(dialog, opener) {
    if (active) close();
    active = { dialog, opener, overflow: document.documentElement.style.overflow };
    try { dialog.showModal(); }
    catch (_) { restore(); return; }
    document.documentElement.style.overflow = 'hidden';
    dialog.scrollTop = 0;
    dialog.querySelector('[data-ro-collection-close]').focus({ preventScroll: true });
  }
  function onClick(event) {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('[data-ro-collection]');
    if (!root) return;
    const quick = event.target.closest('[data-ro-quick-open]');
    if (quick) {
      if (busy) { say(root, t(root).adding); return; }
      const template = quick.closest('[data-ro-card]').querySelector('[data-ro-quick-template]');
      const dialog = root.querySelector('[data-ro-quick-dialog]');
      if (!template || !dialog) return;
      dialog.querySelector('[data-ro-quick-content]').replaceChildren(template.content.cloneNode(true));
      open(dialog, quick);
      return;
    }
    const wish = event.target.closest('[data-ro-wishlist-toggle]');
    if (wish) {
      const card = wish.closest('[data-ro-card]');
      const saved = listFor(root);
      const index = saved.findIndex(x => x.id === card.dataset.productId);
      if (index >= 0) saved.splice(index, 1);
      else {
        if (saved.length >= 100) { say(root, t(root).limit); return; }
        saved.push({ id: card.dataset.productId, handle: card.dataset.productHandle, title: card.dataset.productTitle, material: card.dataset.productMaterial, image: safeImage(card.dataset.productImage || '') });
      }
      save(root); refresh();
      say(root, !storageOK && root.dataset.editor !== 'true' ? t(root).storage : index >= 0 ? t(root).removed : t(root).saved);
      return;
    }
    const showWishlist = event.target.closest('[data-ro-wishlist-open]');
    if (showWishlist) {
      renderWishlist(root); open(root.querySelector('[data-ro-wishlist-dialog]'), showWishlist); return;
    }
    const remove = event.target.closest('[data-ro-wishlist-remove]');
    if (remove) {
      const saved = listFor(root);
      const index = saved.findIndex(x => x.id === remove.dataset.roWishlistRemove);
      if (index >= 0) saved.splice(index, 1);
      save(root); refresh(); renderWishlist(root);
      const next = root.querySelectorAll('[data-ro-wishlist-remove]');
      (next[Math.min(Math.max(index, 0), next.length - 1)] || root.querySelector('[data-ro-wishlist-dialog] [data-ro-collection-close]')).focus();
      return;
    }
    if (event.target.closest('[data-ro-collection-close]')) { close(); return; }
    if (active && event.target === active.dialog) {
      const box = active.dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    }
  }
  function onChange(event) {
    const select = event.target;
    if (!(select instanceof Element) || !select.matches('[data-ro-quick-variant]')) return;
    const form = select.closest('[data-ro-quick-form]');
    if (!form || busy) return;
    const root = form.closest('[data-ro-collection]');
    const option = select.selectedOptions[0];
    form.querySelector('button[type="submit"]').disabled = !option || !option.value || option.disabled || completed.has(form);
    if (option && option.value && !option.disabled) {
      form.closest('[data-ro-quick-content]').querySelector('[data-ro-quick-price]').textContent = option.dataset.price;
      const quantity = Number(option.dataset.quantity || 1);
      const quantityLine = form.querySelector('[data-ro-quick-quantity]');
      quantityLine.hidden = quantity <= 1;
      quantityLine.textContent = t(root).quantity + ': ' + quantity;
    }
    form.querySelector('[data-ro-quick-status]').textContent = '';
  }
  async function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof Element) || !form.matches('[data-ro-quick-form]')) return;
    event.preventDefault();
    const root = form.closest('[data-ro-collection]');
    if (!root || busy || completed.has(form)) return;
    const text = t(root);
    const select = form.querySelector('[data-ro-quick-variant]');
    const option = select.selectedOptions[0];
    const status = form.querySelector('[data-ro-quick-status]');
    if (!option || !option.value || option.disabled) { status.textContent = text.choose; select.focus(); return; }
    if (root.dataset.editor === 'true' || form.dataset.preview === 'true' || window.Shopify?.designMode) {
      status.textContent = text.preview; return;
    }
    if (!/^\d+$/.test(option.value)) { status.textContent = text.unavailable; return; }
    const button = form.querySelector('button[type="submit"]');
    const quantity = Math.max(1, Number(option.dataset.quantity) || 1);
    busy = true; select.disabled = true; button.disabled = true; button.textContent = text.adding;
    form.setAttribute('aria-busy', 'true'); status.textContent = text.adding;
    let failureMessage = text.error;
    try {
      const response = await fetch(form.dataset.ajaxUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: option.value, quantity }] })
      });
      let result;
      try { result = await response.json(); } catch (_) { throw new Error(text.error); }
      if (!response.ok || result.status >= 400) {
        if (typeof result.description === 'string') failureMessage = result.description;
        throw new Error(failureMessage);
      }
      if (!Array.isArray(result.items) || !result.items.some(item => String(item.variant_id || item.id) === option.value)) throw new Error(text.error);
      completed.add(form);
      if (!destroyed) {
        status.textContent = text.added; button.textContent = text.added;
        form.querySelector('[data-ro-quick-cart]').hidden = false;
        say(root, text.added);
        if (form.isConnected && active?.dialog.contains(form)) form.querySelector('[data-ro-quick-cart]').focus();
      }
    } catch (error) {
      if (!destroyed) { status.textContent = failureMessage; form.querySelector('[data-ro-quick-cart]').hidden = false; button.textContent = text.add; }
    } finally {
      busy = false; form.removeAttribute('aria-busy');
      if (!completed.has(form)) { select.disabled = false; button.disabled = false; }
      // Read the actual total, including any partial server-side addition after an error.
      document.dispatchEvent(new CustomEvent('ro:cart-changed'));
    }
  }
  function onClose(event) { if (active?.dialog === event.target && !event.target.open) restore(); }
  function onUnload(event) { if (active && event.target instanceof Element && event.target.contains(active.dialog)) close(); }
  function init() {
    if (destroyed || typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    document.querySelectorAll('[data-ro-collection] [data-ro-enhanced]').forEach(el => { el.hidden = false; });
    refresh();
  }
  function onStorage(event) {
    if (event.key !== KEY && event.key !== null) return;
    read(); refresh();
    if (active?.dialog.matches('[data-ro-wishlist-dialog]')) renderWishlist(active.dialog.closest('[data-ro-collection]'));
  }
  read();
  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('submit', onSubmit);
  document.addEventListener('close', onClose, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', onUnload);
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('storage', onStorage);
  init();
  window.roCollectionController = { destroy() {
    destroyed = true; close();
    document.removeEventListener('click', onClick);
    document.removeEventListener('change', onChange);
    document.removeEventListener('submit', onSubmit);
    document.removeEventListener('close', onClose, true);
    document.removeEventListener('shopify:section:load', init);
    document.removeEventListener('shopify:section:unload', onUnload);
    document.removeEventListener('DOMContentLoaded', init);
    window.removeEventListener('storage', onStorage);
  } };
})();
